<template>
  <v-navigation-drawer permanent expand-on-hover app :src="backgroundImage" dark>
    <v-menu :close-on-content-click="false" :nudge-width="-25">
      <template v-slot:activator="{ on }">
        <v-list>
          <v-list-item class="px-2" v-on="on">
            <v-list-item-avatar>
              <v-img :src="imgLogo"></v-img>
            </v-list-item-avatar>
            <v-list-item-title class="title">{{ title }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list nav>
          <!-- Exercise parts -->
          <template v-if="title == 'ENE'">
            <v-list-item link to="/hub">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Accueil</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/exercises" v-if="canViewExercises">
              <v-list-item-icon>
                <v-icon>mdi-view-list</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Exercices</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/exercise" v-if="canManageExercises">
              <v-list-item-icon>
                <v-icon>mdi-content-paste</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Créer un exercice</v-list-item-title>
            </v-list-item>
          </template>

          <!-- Cycle parts -->
          <template v-else-if="title == 'GCE'">
            <v-list-item link to="/hub">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Accueil</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/cycles" v-if="canViewCycles">
              <v-list-item-icon>
                <v-icon>mdi-view-list</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Cycles</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/cycle" v-if="canManageCycles">
              <v-list-item-icon>
                <v-icon>mdi-shape-circle-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Créer un cycle</v-list-item-title>
            </v-list-item>
          </template>

          <!-- Only Hub -->
          <template v-else>
            <v-list-item link to="/hub">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Accueil</v-list-item-title>
            </v-list-item>
          </template>

          <v-divider></v-divider>

          <!-- Admin Panel -->
          <v-list-item link to="/adminpanel/users" v-if="canViewAdminPanel">
            <v-list-item-icon>
              <v-icon>mdi-account-box</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Admin</v-list-item-title>
          </v-list-item>

          <!-- Federations Panels -->
          <v-menu v-if="canViewOwnFederation && userFederations && userFederations.length > 0">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" link>
                <v-list-item-icon>
                  <v-icon>mdi-office-building</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Fédération</v-list-item-title>
              </v-list-item>
            </template>

            <v-list>
              <v-list-item v-for="(item, index) in userFederations" :key="index" @click="toFederation(item)">
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Disciplines Panels -->
          <v-menu v-if="canManageOwnDiscipline && userDisciplines && userDisciplines.length > 0">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" link>
                <v-list-item-icon>
                  <v-icon>mdi-widgets-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Discipline</v-list-item-title>
              </v-list-item>
            </template>

            <v-list>
              <v-list-item v-for="(item, index) in userDisciplines" :key="index" @click="toDiscipline(item)">
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- Coach Panel -->
          <v-list-item @click="toCoachPanel()" v-if="!canManageOwnDiscipline && canViewCoachPanel && userDisciplines && userDisciplines.length > 0">
            <v-list-item-icon>
              <v-icon>mdi-whistle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Entraîneur</v-list-item-title>
          </v-list-item>

          <!-- My Profile -->
          <v-list-item link to="/profile">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mon profil</v-list-item-title>
          </v-list-item>

          <!-- My Medias -->
          <v-list-item link to="/medias" v-if="canViewOwnMedias">
            <v-list-item-icon>
              <v-icon>mdi-folder-multiple-image</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mes Médias</v-list-item-title>
          </v-list-item>

          <!-- Logout -->
          <v-list-item @click="logout()">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Se déconnecter</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>

      <v-list>
        <v-list-item v-for="item in listItem" :key="item.title" @click="redirect(item)">
          <v-list-item-avatar>
            <img :src="item.imgLogo" alt />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-navigation-drawer>
</template>

<script>
import { bus } from "@/main";
import conf from "@/configs";
import AuthService from "@/services/AuthService";
import PermissionsService from "@/services/PermissionsService";

export default {
  data() {
    return {
      title: "ENE",
      listItem: conf.listItem,
      imgLogo: require("@/assets/LogoENE.png"),
      backgroundImage: require("@/assets/img/sidebar.jpg"),
    };
  },

  props: {
    sidebarLinks: {
      type: Array,
      default: () => [],
    },

    autoClose: {
      type: Boolean,
      default: true,
    },
  },

  provide() {
    return {
      autoClose: this.autoClose,
    };
  },

  async mounted() {
    const { meta } = this.$route;

    if (meta.section) {
      const [item] = conf.listItem.filter((item) => item.title === meta.section);
      this.changeSection(item);
    }

    bus.$on("appChange", (item) => {
      this.title = item.title;
      this.backgroundImage = item.backgroundImage;
      this.imgLogo = item.imgLogo;
    });

    // await this.initFederations();
  },

  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },

    userFederations() {
      return AuthService.federations;
    },

    userId() {
      return AuthService.userId;
    },

    // Can be provided from managerDisciplines or from coachDisciplines backend side
    userDisciplines() {
      return AuthService.disciplines;
    },

    canViewExercises() {
      return PermissionsService.ExercisesPermissionsService.canViewOwnExercises || PermissionsService.ExercisesPermissionsService.canViewAllExercises;
    },

    canManageExercises() {
      return PermissionsService.ExercisesPermissionsService.canManageOwnExercises || PermissionsService.ExercisesPermissionsService.canManageAllExercises;
    },

    canViewCycles() {
      return PermissionsService.CyclesPermissionsService.canViewOwnCycles || PermissionsService.CyclesPermissionsService.canViewAllCycles;
    },

    canManageCycles() {
      return PermissionsService.CyclesPermissionsService.canManageOwnCycles || PermissionsService.CyclesPermissionsService.canManageAllCycles;
    },

    canViewAdminPanel() {
      return (
        PermissionsService.RolesPermissionsService.canViewAllRoles ||
        PermissionsService.UsersPermissionsService.canViewAllUsers ||
        PermissionsService.FederationsPermissionsService.canViewAllFederations
      );
    },

    canViewOwnFederation() {
      return PermissionsService.FederationsPermissionsService.canViewOwnFederation || PermissionsService.FederationsPermissionsService.canViewAllFederations;
    },

    canManageOwnDiscipline() {
      return PermissionsService.DisciplinesPermissionsService.canManageOwnDiscipline || PermissionsService.DisciplinesPermissionsService.canManageAllDisciplinesOwnFederation;
    },

    canViewCoachPanel() {
      return PermissionsService.TeamsPermissionsService.canManageOwnTeam || PermissionsService.TeamsPermissionsService.canViewAllTeamsOwnDiscipline;
    },

    canViewOwnMedias() {
      return PermissionsService.MediasPermissionsService.canViewOwnMedias || PermissionsService.MediasPermissionsService.canViewAllMedias;
    },
  },

  methods: {
    redirect(item) {
      this.changeSection(item);
      this.$router.push(item.link);
    },

    changeSection(item) {
      this.imgLogo = item.imgLogo;
      this.backgroundImage = item.backgroundImage;
      this.title = item.title;
    },

    toFederation(item) {
      this.$router.push({
        name: "FederationPanel",
        params: {
          tab: "users",
          federationId: item.id,
        },
      });
    },

    toDiscipline(item) {
      this.$router.push({
        name: "DisciplinePanel",
        params: {
          federationId: item.parentFederationId,
          disciplineId: item.id,
          tab: "disciplineManagers",
        },
      });
    },

    toCoachPanel() {
      this.$router.push({
        name: "CoachPanel",
        params: {
          federationId: this.userDisciplines[0].parentFederationId,
          disciplineId: this.userDisciplines[0].id,
          coachId: this.userId,
          tab: "users",
        },
      });
    },

    logout() {
      AuthService.logout();
      this.$router.replace("/login");
    },
  },
};
</script>

<style>
@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }

  .v-list--nav a {
    color: #d8d179 !important;
  }
}
</style>
